// watches the height of an element
// intended for use with iframe message service to notify parent frames when a container has resized

(function() {
        'use strict';

        angular
            .module('vhols')
            .directive('vhmHeightWatcher', vhmHeightWatcher);

        vhmHeightWatcher.$inject = ['iFrameMessagingService'];

        function vhmHeightWatcher (iFrameMessagingService) {

            var height = -1,
                newHeight,
                directive = {
                    link: link,
                    restrict: 'A'
                };

            return directive;

            function link(scope, element) {

                watchHeight();

                function watchHeight() {
                    newHeight = element[0].clientHeight;

                    if(newHeight !== height) {
                        height = newHeight;
                        sendResizeEvent(newHeight);
                    }

                    requestAnimationFrame(watchHeight);
                }

            }

            function sendResizeEvent(height){
                var payload = {
                    type: 'resize',
                    source: 'vhm-callback-form',
                    value: {
                        height: height
                    }

                };
                iFrameMessagingService.sendMessage(payload);
            }
        }

    })();
